import { BudgetCreatedEventTypeStrategy } from "./BudgetCreatedEventTypeStrategy";
import { BudgetRenewedEventTypeStrategy } from "./BudgetRenewedEventTypeStrategy";
import { CampaignBudgetAllocatedEventTypeStrategy } from "./CampaignBudgetAllocatedEventTypeStrategy";
import { CampaignBudgetRemovedEventTypeStrategy } from "./CampaignBudgetRemovedEventTypeStrategy";
import { CampaignBudgetUpdatedEventTypeStrategy } from "./CampaignBudgetUpdatedEventTypeStrategy";
import { CampaignInvoicedEventTypeStrategy } from "./CampaignInvoicedEventTypeStrategy";
import { CampaignInvoiceUpdatedEventTypeStrategy } from "./CampaignInvoiceUpdatedEventTypeStrategy";
import { ChannelBudgetAllocatedEventTypeStrategy } from "./ChannelBudgetAllocatedEventTypeStrategy";
import { ChannelBudgetRemovedEventTypeStrategy } from "./ChannelBudgetRemovedEventTypeStrategy";
import { ChannelBudgetUpdatedEventTypeStrategy } from "./ChannelBudgetUpdatedEventTypeStrategy";
import { ChannelInvoicedEventTypeStrategy } from "./ChannelInvoicedEventTypeStrategy";
import { ChannelInvoiceUpdatedEventTypeStrategy } from "./ChannelInvoiceUpdatedEventTypeStrategy";
import { ClientBudgetBudgetCapUpdatedEventTypeStrategy } from "./ClientBudgetBudgetCapUpdatedEventTypeStrategy";
import { ClientBudgetPaymentTypeUpdatedEventStrategy } from "./ClientBudgetPaymentTypeUpdatedEventStrategy";
import { DefaultEventTypeStrategy } from "./DefaultEventTypeStrategy";
import { EventTypeStrategy } from "./EventTypeStrategy";
import { MonthlyBudgetEventTypeStrategy } from "./MonthlyBudgetEventTypeStrategy";
import { OverspendAllowedChangedEventTypeStrategy } from "./OverspendAllowedChangedEventTypeStrategy";
import { normalizeEventType } from "../../utils/eventTypeUtils";

import { BudgetEventType } from "@/lib/utils/clientBudgetEventTypeMap";
import { TransactionType } from "@/types/transaction/TransactionType";

export function getEventTypeStrategy(
  eventType: TransactionType["eventType"],
): EventTypeStrategy {
  // Normalize the event type to remove prefixes (SubscriptionBudget, PostpaidBudget, etc.)
  const normalizedType = normalizeEventType(eventType);

  switch (normalizedType) {
  case BudgetEventType.BUDGET_CAP_UPDATED:
    return new ClientBudgetBudgetCapUpdatedEventTypeStrategy();
  case BudgetEventType.BUDGET_RENEWED:
    return new BudgetRenewedEventTypeStrategy();
  case BudgetEventType.CAMPAIGN_BUDGET_ALLOCATED:
  case BudgetEventType.CAMPAIGN_INTEGRATION_BUDGET_ALLOCATED:
    return new CampaignBudgetAllocatedEventTypeStrategy();
  case BudgetEventType.CAMPAIGN_BUDGET_REMOVED:
  case BudgetEventType.CAMPAIGN_INTEGRATION_BUDGET_REMOVED:
    return new CampaignBudgetRemovedEventTypeStrategy();
  case BudgetEventType.CAMPAIGN_BUDGET_UPDATED:
  case BudgetEventType.CAMPAIGN_INTEGRATION_BUDGET_UPDATED:
    return new CampaignBudgetUpdatedEventTypeStrategy();
  case BudgetEventType.CAMPAIGN_INVOICE_UPDATED:
  case BudgetEventType.CAMPAIGN_INTEGRATION_INVOICE_UPDATED:
    return new CampaignInvoiceUpdatedEventTypeStrategy();
  case BudgetEventType.CAMPAIGN_INVOICED:
  case BudgetEventType.CAMPAIGN_INTEGRATION_INVOICED:
    return new CampaignInvoicedEventTypeStrategy();
  case BudgetEventType.CHANNEL_BUDGET_ALLOCATED:
    return new ChannelBudgetAllocatedEventTypeStrategy();
  case BudgetEventType.CHANNEL_BUDGET_REMOVED:
    return new ChannelBudgetRemovedEventTypeStrategy();
  case BudgetEventType.CHANNEL_BUDGET_UPDATED:
    return new ChannelBudgetUpdatedEventTypeStrategy();
  case BudgetEventType.CHANNEL_INVOICE_UPDATED:
    return new ChannelInvoiceUpdatedEventTypeStrategy();
  case BudgetEventType.CHANNEL_INVOICED:
    return new ChannelInvoicedEventTypeStrategy();
  case BudgetEventType.MONTHLY_BUDGET_UPDATED:
    return new MonthlyBudgetEventTypeStrategy();
  case BudgetEventType.OVERSPEND_ALLOWED_CHANGED:
    return new OverspendAllowedChangedEventTypeStrategy();
  case BudgetEventType.PAYMENT_TYPE_UPDATED:
    return new ClientBudgetPaymentTypeUpdatedEventStrategy();
  case BudgetEventType.POSTPAID_BUDGET_CREATED:
    return new BudgetCreatedEventTypeStrategy();
  case BudgetEventType.SUBSCRIPTION_BUDGET_CREATED:
    return new DefaultEventTypeStrategy();
  default:
    return new DefaultEventTypeStrategy();
  }
}
